import { render, staticRenderFns } from "./OrderCreatorServiceMachineComments.vue?vue&type=template&id=6e26ac84&"
import script from "./OrderCreatorServiceMachineComments.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceMachineComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports